<template>
    <v-container class="pa-0 ma-0" fluid style="background-color: #EEEEE7; height:100% ">
        <v-toolbar class="slide-card-up mb-8" dense :color="'#FBFAF1'" style="min-height: 80px;">
            <v-spacer></v-spacer>
            <v-toolbar-title class="mt-6 text-center">
                <img src="../assets/logo7.svg" alt="Logo" style="height: 60px;">
            </v-toolbar-title>
            <v-spacer></v-spacer>
        </v-toolbar>

        <v-row dense class="slide-card-up" justify="center">
            <h1 v-if="camino != null" class="mt-0 ma-4 mr-12">{{ $t('mensajes.inicial') }} {{ agencia && agencia.nombre ?
                agencia.nombre : '' }}</h1>
        </v-row>
        <v-row v-if="camino != null" dense class="slide-card-up">
            <v-col class="text-center">
                <p style="font-size: 1.2rem;" class="mx-16">
                    {{ $t('mensajes.descripcion') }}
                </p>
            </v-col>
        </v-row>

        <v-container>
            <v-row justify="center" v-if="pasajerosGuardados">
                <v-col justify="center">
                    <h2 class="text-center">
                        {{ $t('mensajes.datos_pasajeros.mensaje_final_success') }}
                    </h2>
                    <div v-if="mostrarBotonVolver" class="d-flex justify-center mt-6">
                        <v-chip
                            link
                            large
                            class="ma-2 px-8"
                            :color="miColorAzul"
                            :text-color="miColorNaranja"
                            style="font-size: 1.2rem;"
                            @click="volverAlExpediente"
                        >
                            <v-icon left small>mdi-arrow-left</v-icon>
                            Volver al expediente
                        </v-chip>
                    </div>
                </v-col>
            </v-row>

            <v-row justify="center" v-if="!pasajerosGuardados">
                <v-col align="center">
                    <v-row class="mt-0 mb-2">
                        <v-col justify="start">
                            <p class="mx-0" style="text-align: start;">
                                {{ $t('mensajes.datos_pasajeros.titulo') }}
                            </p>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col v-for="(pasajero, index) in pasajeros" :key="index" cols="12" md="6" class="d-flex">
                            <v-card class="mx-2 pa-4 card-personalizada slide-card flex-grow-1">
                                <v-card-title>
                                    {{ $t('mensajes.datos_pasajeros.datos_peregrino', { index: index + 1 }) }}
                                </v-card-title>
                                <v-card-text>
                                    <v-row dense class="mt-6 mb-2">
                                        <v-text-field
                                            v-model="pasajero.nombre"
                                            class="mb-2"
                                            :class="{ 'required-field': isRequiredFieldMissing(pasajero, 'nombre') }"
                                            :label="$t('mensajes.datos_pasajeros.nombre')"
                                            type="text"
                                            outlined
                                            dense
                                            autocomplete="off"
                                            hide-details
                                        />
                                    </v-row>

                                    <v-row dense class="mb-2">
                                        <v-col cols="6">
                                            <v-text-field
                                                v-model="pasajero.primer_apellido"
                                                class="mb-2"
                                                :class="{ 'required-field': isRequiredFieldMissing(pasajero, 'primer_apellido') }"
                                                :label="$t('mensajes.datos_pasajeros.primer_apellido')"
                                                type="text"
                                                outlined
                                                dense
                                                autocomplete="off"
                                                hide-details
                                            />
                                        </v-col>
                                        <v-col cols="6">
                                            <v-text-field
                                                v-model="pasajero.segundo_apellido"
                                                class="mb-2"
                                                :class="{ 'required-field': isRequiredFieldMissing(pasajero, 'segundo_apellido') }"
                                                :label="$t('mensajes.datos_pasajeros.segundo_apellido')"
                                                type="text"
                                                outlined
                                                dense
                                                autocomplete="off"
                                                hide-details
                                            />
                                        </v-col>
                                    </v-row>

                                    <v-row dense class="mb-5">
                                        <v-text-field
                                            v-model="pasajero.numero_documento"
                                            :class="{ 'required-field': isRequiredFieldMissing(pasajero, 'numero_documento') }"
                                            :label="$t('mensajes.datos_pasajeros.numero_documento')"
                                            type="text"
                                            outlined
                                            dense
                                            autocomplete="off"
                                            hide-details
                                            @input="pasajero.numero_documento = $event.toUpperCase()"
                                        />
                                    </v-row>

                                    <v-row dense class="mb-2">
                                        <v-text-field
                                            v-model="pasajero.telefono_movil"
                                            :class="{ 'required-field': isRequiredFieldMissing(pasajero, 'telefono_movil') }"
                                            :label="$t('mensajes.datos_pasajeros.telefono_movil')"
                                            type="text"
                                            outlined
                                            dense
                                            autocomplete="off"
                                            hide-details
                                        />
                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>

                    <v-row justify="end" align="center" class="mt-4">
                        <v-col cols="12" sm="8" md="4" lg="3" class="py-0">
                            <v-text-field
                                v-model="modelReserva.codigo_agencia"
                                dense
                                outlined
                                hide-details="auto"
                                label="Código de Referencia de la Agencia"
                                class="mb-2"
                                :class="{ 'required-field': isMissingValue(modelReserva.codigo_agencia) }"
                            />
                        </v-col>
                        <v-col cols="12" md="auto" class="py-0 d-flex justify-end">
                            <v-chip
                                link
                                large
                                @click="formulariosValidados() ? _guardarDatosPasajeros() : null"
                                class="ma-2 px-8 mr-md-8"
                                :class="{ 'hover-color': formulariosValidados() }"
                                :color="formulariosValidados() ? miColorAzul : 'grey'"
                                :text-color="formulariosValidados() ? miColorNaranja : 'white'"
                                style="font-size: 1.2rem;"
                            >
                                {{ $t('mensajes.datos_pasajeros.confirmar_datos') }}
                                <v-icon size="2rem" right>mdi-arrow-right</v-icon>
                            </v-chip>
                        </v-col>
                    </v-row>

                    <v-row justify="start" class="mx-4 mt-12 mb-12">
                        <p class="mx-0" style="font-size: 0.8rem; text-align: start;">
                            {{ $t('mensajes.datos_pasajeros.politica_privacidad') }}
                        </p>
                    </v-row>
                </v-col>
            </v-row>
        </v-container>
    </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
    name: 'RegistroViajerosAgencia',
    data() {
        return {
            language: 'es',
            pasajerosGuardados: false,
            miColorNaranja: '#FF9C00',
            miColorAzul: '#191970',
            modelReserva: {
                id: null,
                codigo: null,
                codigo_agencia: '',
                camino: null,
                fecha_inicio: null,
                fecha_llegada: null,
                cant_peregrinos: 0,
                cliente: {
                    nombre: '',
                    apellidos: '',
                    telefono: '',
                    email: '',
                },
                pasajeros: [],
            },
            pasajeros: [],
            requiredPassengerFields: [
                'nombre',
                'primer_apellido',
                'segundo_apellido',
                'numero_documento',
                'telefono_movil'
            ],
        };
    },
    computed: {
        ...mapState('caminos', ['camino', 'agencia']),
        mostrarBotonVolver() {
            return !!this.rutaVolverExpediente || window.history.length > 1;
        },
        rutaVolverExpediente() {
            const agencia = this.$route && this.$route.query ? this.$route.query.agencia : '';
            const codigo = this.$route && this.$route.query ? this.$route.query.codigo : '';

            if (!agencia || !codigo) {
                return null;
            }

            return {
                name: 'central_reservas_ext',
                params: {
                    agencia
                },
                query: {
                    tab: 'expedientes',
                    codigo
                }
            };
        }
    },
    created() {
        this.pasajerosGuardados = false;
    },
    mounted() {
        this.language = this.$route.params.language.toLowerCase();
        this.$i18n.locale = this.language.toLowerCase();
        const hash = this.$route.params.hash;
        if (hash) {
            this._getReservaByHash(hash);
        }
    },
    methods: {
        ...mapActions('caminos', ['guardarDatosPasajeros', 'getReservaByHash']),

        async _getReservaByHash(hash) {
            const reserva = await this.getReservaByHash([hash]);
            this.modelReserva.id = reserva.id;
            this.modelReserva.codigo = reserva.codigo;
            this.modelReserva.codigo_agencia = reserva.codigo_agencia || '';
            this.modelReserva.fecha_inicio = reserva.fecha_inicio;
            this.modelReserva.fecha_llegada = reserva.fecha_llegada;
            this.modelReserva.cant_peregrinos = reserva.cant_peregrinos;
            this.modelReserva.camino = reserva.camino;
            this.modelReserva.cliente.nombre = reserva.cliente.nombre;
            this.modelReserva.cliente.apellidos = reserva.cliente.apellidos;
            this.modelReserva.cliente.telefono = reserva.cliente.telefono;
            this.modelReserva.cliente.email = reserva.cliente.email;
            this.modelReserva.pasajeros = reserva.pasajeros;
            this._pedirDatosPasajeros();
        },

        _pedirDatosPasajeros() {
            const tipoDocumentoPorDefecto = this.language === 'es' ? 'DNI' : 'PASAPORTE';
            this.pasajeros = Array.from({ length: this.modelReserva.cant_peregrinos }, (_, index) => {
                const pasajeroExistente = this.modelReserva.pasajeros && this.modelReserva.pasajeros[index];
                return {
                    codigo_postal: pasajeroExistente?.codigo_postal || null,
                    direccion: pasajeroExistente?.direccion || null,
                    documento: pasajeroExistente?.documento || null,
                    email: pasajeroExistente?.email || null,
                    fecha_nacimiento: pasajeroExistente?.fecha_nacimiento || null,
                    id: pasajeroExistente?.id || null,
                    nacionalidad: pasajeroExistente?.nacionalidad || null,
                    nombre: pasajeroExistente?.nombre || null,
                    numero_documento: pasajeroExistente?.numero_documento || null,
                    parentesco: pasajeroExistente?.parentesco || null,
                    poblacion: pasajeroExistente?.poblacion || null,
                    primer_apellido: pasajeroExistente?.primer_apellido || null,
                    provincia: pasajeroExistente?.provincia || null,
                    reserva_id: pasajeroExistente?.reserva_id || this.modelReserva.id,
                    segundo_apellido: pasajeroExistente?.segundo_apellido || null,
                    sexo: pasajeroExistente?.sexo || null,
                    soporte_documento: pasajeroExistente?.soporte_documento || null,
                    telefono_fijo: pasajeroExistente?.telefono_fijo || null,
                    telefono_movil: pasajeroExistente?.telefono_movil || null,
                    tipo_documento: pasajeroExistente?.tipo_documento || tipoDocumentoPorDefecto,
                };
            });
        },

        isMissingValue(value) {
            if (value === null || value === undefined) return true;
            if (typeof value === 'string') return value.trim() === '';
            return false;
        },

        isRequiredFieldMissing(pasajero, field) {
            if (!this.requiredPassengerFields.includes(field)) return false;
            return this.isMissingValue(pasajero?.[field]);
        },

        formulariosValidados() {
            const codigoAgenciaValido = !this.isMissingValue(this.modelReserva.codigo_agencia);

            return codigoAgenciaValido && this.pasajeros.every(pasajero =>
                this.requiredPassengerFields.every(field => !this.isMissingValue(pasajero?.[field]))
            );
        },

        volverAlExpediente() {
            if (this.rutaVolverExpediente) {
                this.$router.push(this.rutaVolverExpediente).catch(() => {});
                return;
            }

            if (window.history.length > 1) {
                this.$router.go(-1);
            }
        },

        async _guardarDatosPasajeros() {
            if (!this.formulariosValidados()) {
                return;
            }

            this.modelReserva.codigo_agencia = this.modelReserva.codigo_agencia
                ? this.modelReserva.codigo_agencia.toString().trim()
                : '';

            const pasajerosConvertidos = this.pasajeros
                .filter(pasajero => pasajero.nombre && pasajero.nombre.trim() !== '')
                .map(pasajero => ({
                    ...pasajero,
                }));

            const response = await this.guardarDatosPasajeros([this.modelReserva, pasajerosConvertidos]);
            if (response) {
                this.pasajerosGuardados = true;
            }
        },
    },
};
</script>

<style scoped>
.card-personalizada {
    border: none !important;
    border-radius: 15px !important;
}

.required-field ::v-deep .v-label {
    color: #d32f2f !important;
}

.required-field ::v-deep .v-label::after {
    content: ' *';
    color: #d32f2f;
}

.slide-card {
    animation: slideIn 0.5s ease-out;
}

@keyframes slideIn {
    from {
        transform: translateX(100%);
        opacity: 0;
    }

    to {
        transform: translateX(0);
        opacity: 1;
    }
}

.slide-card.v-leave-active {
    animation: slideOut 0.5s ease-in;
}

@keyframes slideOut {
    from {
        transform: translateX(0);
        opacity: 1;
    }

    to {
        transform: translateX(-100%);
        opacity: 0;
    }
}

.slide-card-up {
    animation: slideInUp 0.5s ease-out;
}

@keyframes slideInUp {
    from {
        transform: translateY(-100%);
        opacity: 0;
    }

    to {
        transform: translateY(0);
        opacity: 1;
    }
}

.slide-card-up.v-leave-active {
    animation: slideOutDown 0.5s ease-in;
}

@keyframes slideOutDown {
    from {
        transform: translateY(0);
        opacity: 1;
    }

    to {
        transform: translateY(100%);
        opacity: 0;
    }
}
</style>
